import { TargetCoverageMeta } from "models/Target/targetCoverageMeta.model";

export function mapDesiredData(data:TargetCoverageMeta[]) {
    return data.map(item => {
        const label = item?.value ? item.value
            .split('_')
            .map(scope => scope.replace('scope', '')) // Remove "scope" prefix
            .join(', ') : '';

        return {
            label: `Scope ${label} ${!item.disabled ? '(Coming Soon)' : ''}`, // Add "Scope" only once at the beginning
            value: item.value,
            disabled: !item.disabled
        };
    });
}